import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getResizedImageUrl(url, options = "width=800,quality=80,format=auto") {
  if (!url || !url.startsWith("https://assets.auxodev.dk/")) {
    return url;
  }
  return url.replace("https://assets.auxodev.dk/", `https://assets.auxodev.dk/cdn-cgi/image/${options}/`);
}

export function getImageSrcSet(url, widths = [400, 800, 1200, 1600], quality = 80) {
  if (!url || !url.startsWith("https://assets.auxodev.dk/")) {
    return undefined;
  }
  return widths
    .map((w) => `${getResizedImageUrl(url, `width=${w},quality=${quality},format=auto`)} ${w}w`)
    .join(", ");
}
